<template>
  <div>
    <!-- Form element that submits all the data in the form to Firebase using the submitData method -->
    <form @submit.prevent="$emit('form-submit', form, day)">
      <!-- Add form fields here, wrapped in a div with a class of field -->
      <div class="field">
        <p>Pain with full bladder today</p>
        <Radios
          name="fill-bladder-pain"
          :entry="existingEntry"
          @store-number="storeFullBladderPain"
          data="fullBladderPain"
          amount="11"
        />
      </div>

      <div class="field">
        <p>Pain with emptying bladder today</p>
        <Radios
          name="empty-bladder-pain"
          :entry="existingEntry"
          @store-number="storeEmptyBladderPain"
          data="emptyBladderPain"
          amount="11"
        />
      </div>

      <div class="field">
        <p>Has frequent urination been a problem today?</p>
        <div class="radio">
          <input
            type="radio"
            id="frequent-no-problem"
            value="no problem"
            name="frequent-urination"
            v-model="form.frequentUrination"
          />
          <label for="frequent-no-problem">No problem</label>
        </div>

        <div class="radio">
          <input
            type="radio"
            id="frequent-very-small-problem"
            value="very small problem"
            name="frequent-urination"
            v-model="form.frequentUrination"
          />
          <label for="frequent-very-small-problem">Very small problem</label>
        </div>

        <div class="radio">
          <input
            type="radio"
            id="frequent-small-problem"
            value="small problem"
            name="frequent-urination"
            v-model="form.frequentUrination"
          />
          <label for="frequent-small-problem">Small problem</label>
        </div>

        <div class="radio">
          <input
            type="radio"
            id="frequent-medium-problem"
            value="medium problem"
            name="frequent-urination"
            v-model="form.frequentUrination"
          />
          <label for="frequent-medium-problem">Medium problem</label>
        </div>

        <div class="radio">
          <input
            type="radio"
            id="frequent-big-problem"
            value="big problem"
            name="frequent-urination"
            v-model="form.frequentUrination"
          />
          <label for="frequent-big-problem">Big problem</label>
        </div>
      </div>

      <div class="field">
        <p>Has getting up at night to urinate been a problem last night?</p>
        <div class="radio">
          <input
            type="radio"
            id="night-no-problem"
            value="no problem"
            name="night-urination"
            v-model="form.nightUrination"
          />
          <label for="night-no-problem">No problem</label>
        </div>

        <div class="radio">
          <input
            type="radio"
            id="night-very-small-problem"
            value="very small problem"
            name="night-urination"
            v-model="form.nightUrination"
          />
          <label for="night-very-small-problem">Very small problem</label>
        </div>

        <div class="radio">
          <input
            type="radio"
            id="night-small-problem"
            value="small problem"
            name="night-urination"
            v-model="form.nightUrination"
          />
          <label for="night-small-problem">Small problem</label>
        </div>

        <div class="radio">
          <input
            type="radio"
            id="night-medium-problem"
            value="medium problem"
            name="night-urination"
            v-model="form.nightUrination"
          />
          <label for="night-medium-problem">Medium problem</label>
        </div>

        <div class="radio">
          <input
            type="radio"
            id="night-big-problem"
            value="big problem"
            name="night-urination"
            v-model="form.nightUrination"
          />
          <label for="night-big-problem">Big problem</label>
        </div>
      </div>

      <div class="field">
        <p>Has needing to urinate with little warning been a problem today?</p>
        <div class="radio">
          <input
            type="radio"
            id="warning-no-problem"
            value="no problem"
            name="warning-urination"
            v-model="form.warningUrination"
          />
          <label for="warning-no-problem">No problem</label>
        </div>

        <div class="radio">
          <input
            type="radio"
            id="warning-very-small-problem"
            value="very small problem"
            name="warning-urination"
            v-model="form.warningUrination"
          />
          <label for="warning-very-small-problem">Very small problem</label>
        </div>

        <div class="radio">
          <input
            type="radio"
            id="warning-small-problem"
            value="small problem"
            name="warning-urination"
            v-model="form.warningUrination"
          />
          <label for="warning-small-problem">Small problem</label>
        </div>

        <div class="radio">
          <input
            type="radio"
            id="warning-medium-problem"
            value="medium problem"
            name="warning-urination"
            v-model="form.warningUrination"
          />
          <label for="warning-medium-problem">Medium problem</label>
        </div>

        <div class="radio">
          <input
            type="radio"
            id="warning-big-problem"
            value="big problem"
            name="warning-urination"
            v-model="form.warningUrination"
          />
          <label for="warning-big-problem">Big problem</label>
        </div>
      </div>

      <div class="field">
        <p>
          Has burning, pain, discomfort, or pressure in bladder been a problem
          today?
        </p>
        <div class="radio">
          <input
            type="radio"
            id="pain-no-problem"
            value="no problem"
            name="pain-urination"
            v-model="form.painUrination"
          />
          <label for="pain-no-problem">No problem</label>
        </div>

        <div class="radio">
          <input
            type="radio"
            id="pain-very-small-problem"
            value="very small problem"
            name="pain-urination"
            v-model="form.painUrination"
          />
          <label for="pain-very-small-problem">Very small problem</label>
        </div>

        <div class="radio">
          <input
            type="radio"
            id="pain-small-problem"
            value="small problem"
            name="pain-urination"
            v-model="form.painUrination"
          />
          <label for="pain-small-problem">Small problem</label>
        </div>

        <div class="radio">
          <input
            type="radio"
            id="pain-medium-problem"
            value="medium problem"
            name="pain-urination"
            v-model="form.painUrination"
          />
          <label for="pain-medium-problem">Medium problem</label>
        </div>

        <div class="radio">
          <input
            type="radio"
            id="pain-big-problem"
            value="big problem"
            name="pain-urination"
            v-model="form.painUrination"
          />
          <label for="pain-big-problem">Big problem</label>
        </div>
      </div>

      <div class="field">
        <button class="button button--standard" type="submit">
          <span v-if="day.edit">Update</span>
          <span v-else>Log your urinary symptoms</span>
        </button>
        <button
          class="button button--danger"
          v-if="day.edit"
          @click.prevent="$emit('cancel-edit', day)"
        >
          Cancel
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import Radios from "@/components/Radios.vue";

export default {
  name: "Form",
  props: ["existingEntry", "day"],
  components: { Radios },

  methods: {
    storeFullBladderPain(level) {
      this.form.fullBladderPain = level;
    },
    storeEmptyBladderPain(level) {
      this.form.emptyBladderPain = level;
    },
  },

  data() {
    return {
      form: {
        // Add form field data here. This data will be submitted to Firestore and
        // should match the v-model values from your form fields.
        frequentUrination: this.existingEntry
          ? this.existingEntry.data.frequentUrination
          : "",
        nightUrination: this.existingEntry
          ? this.existingEntry.data.nightUrination
          : "",
        warningUrination: this.existingEntry
          ? this.existingEntry.data.warningUrination
          : "",
        painUrination: this.existingEntry
          ? this.existingEntry.data.painUrination
          : "",
      },
    };
  },
};
</script>

<style>
button {
  margin-right: 1rem;
}

fieldset {
  margin-bottom: 2rem;
}

.checkbox,
.radio {
  align-items: center;
  display: flex;
  margin-bottom: 0.5rem;
}

.checkbox input,
.radio input {
  height: auto;
  margin: 0 0.5rem 0 0;
}
</style>
